import React, { ReactElement, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { GaAnalytics } from '../../utils/analytics';
import { SignUpForm } from '../organisms';
import CardHeader from '../organisms/CardHeader';

export default function SignUp(): ReactElement {
  const { search } = useLocation();
  const queryString = new URLSearchParams(search);
  const inApp = queryString.get('inApp');
  const redirectUrl = queryString.get('redirectUrl');

  const loginLink = redirectUrl ? `/login?inApp=${inApp === 'true'}&redirectUrl=${redirectUrl}` : `/login?inApp=${inApp === 'true'}`;
  useEffect(() => {
    GaAnalytics.sendEvent('register_start');
  }, []);
  return (
    <div className="h-100">
      <div className="d-flex align-items-center">
        <div className="mx-auto">
          <div className="card">
            <CardHeader />
            <div className="card-body">
              <h1 className="card-title text-center py-1">Registrazione</h1>

              <p className="card-text">
                <small>
                  Se sei già registrato, accedi alla tua area personale.
                  <br />
                  <Link to={loginLink}>
                    <a rel="keep-params">Accedi al tuo account</a>
                  </Link>
                </small>
              </p>
              <SignUpForm redirectUrl={redirectUrl} inApp={inApp} />
              <form id="verification-form" style={{ display: 'none' }}>
                <div className="form-group">
                  <input type="text" name="verification_code" className="form-control" placeholder="Code di verifica" />
                </div>
                <button type="submit" className="btn btn-primary">
                  Conferma
                </button>
                <a className="" data-action="resend_code" style={{ cursor: 'pointer' }}>
                  Reinvia codice di verifica
                </a>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
